module.exports = __webpack_public_path__ + "img/ru.ab61f31e.svg";